import clsx from 'clsx';
import { RefObject } from 'react';
import s from './NavBar.module.scss';

export const getProfileNavbarClassName = (
  isMobileView?: boolean,
  isRenderedInModal?: boolean,
  showBack?: boolean,
  isMiniContactPanelVisible?: boolean,
): string => {
  const baseNavbarClass = isMobileView
    ? s.scrollingWrapper
    : isRenderedInModal
    ? s.navnoHeader
    : s.nav;

  const backClass =
    !isMobileView && !isRenderedInModal && showBack ? s.withBack : '';
  const miniContactPanelClass =
    isMobileView && isMiniContactPanelVisible ? s.withMiniContactPanel : '';

  return clsx(baseNavbarClass, backClass, miniContactPanelClass);
};

export const getNavContentClass = (isMobileView?: boolean): string =>
  isMobileView ? s.navContentMobile : s.navContentDesktop;

export const getCurrentActiveTab = (
  isMobileView?: boolean,
  activeTab?: string,
  navItemWasClicked?: string,
): string | undefined => (isMobileView ? activeTab : navItemWasClicked);

export const updateWindowHistory = (section: string): void => {
  const { pathname, search } = window.location;
  const url = `${pathname}${search}#${section}`;
  window.history.replaceState(null, '', url);
};

export const focusNavigationElement = (
  navigationRefs: RefObject<Record<string, HTMLElement>>,
  section: string,
  preventScroll = true,
): void => {
  navigationRefs.current?.[section]?.focus({ preventScroll });
};
